const doc = [({"en":({"js":({"admin":({"employee_prices":({"create_card":({"the_employee_price_was_saved":"The employee prices were saved"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;